import { render } from "./FaceScanComponent.vue?vue&type=template&id=1662c766"
import script from "./FaceScanComponent.vue?vue&type=script&lang=js"
export * from "./FaceScanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__